<template>
    <div class="page-wrapper">
      <div class="page-title">
        <CIcon name="cil-location-pin" /> Trips / Treks
        <span class="page-title-badge" v-if="tableLength > 0">{{ tableLength }} records</span>
      </div>
        <CRow>
            <CCol md="12" class="pad-r-0 pad-l-0">
                <CCard>
                    <CCardBody>
                        <CRow>
                            <CCol sm="12">
                                <h4 id="traffic" class="card-title mb-0">Data Filters</h4>
                                <small v-if="items.length > 0"><i>Showing {{items.length}} of {{tableLength}} records</i></small>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="3">
                                <CCallout color="info">
                                <CForm>
                                    <CSelect
                                        label="Select a cirlce"
                                        :options="circle"
                                        :value.sync="selected.circle"
                                        @change="getArea('division', selected.circle, null, null, null)"
                                    />      
                                </CForm>
                                </CCallout>
                            </CCol>
                            <CCol sm="3">
                                <CCallout color="danger">
                                <CForm>
                                    <CSelect
                                        label="Select a division"
                                        :options="division"
                                        :value.sync="selected.division"
                                        @change="getArea('range', selected.circle, selected.division, null, null)"
                                    />      
                                </CForm>
                                </CCallout>
                            </CCol>
                            <CCol sm="3">
                                <CCallout color="warning">
                                <CForm>
                                    <CSelect
                                        label="Select a range"
                                        :options="range"
                                        :value.sync="selected.range"
                                        @change="getArea('block', selected.circle, selected.division, selected.range, null)"
                                    />      
                                </CForm>
                                </CCallout>
                            </CCol>
                            <CCol sm="3">
                                <CCallout color="primary">
                                <CForm>
                                    <CSelect
                                        label="Select a block"
                                        :options="block"
                                        :value.sync="selected.block"
                                        @change="getArea('beat', selected.circle, selected.division, selected.range, selected.block)"
                                    />      
                                </CForm>
                                </CCallout>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="4">
                                <CCallout color="danger">
                                <b>Select Time Interval</b>
                                <CInputRadioGroup
                                    name="sourceTypeRadio"
                                    checked="month"
                                    :options="timeTypeRadio"
                                    :value.sync="selected.sourceType"
                                    @update:checked="updateSourceType"
                                />
                                </CCallout>
                            </CCol>
                            <CCol sm="8" v-if="selected.sourceType == 'month'">
                                <CInput
                                    label="Select any date from desired month"
                                    type="date"
                                    v-model="selected.date"
                                />
                            </CCol>
                            <CCol sm="8" v-if="selected.sourceType == 'year'">
                                <CInput
                                    label="Select any date from desired year"
                                    type="date"
                                    v-model="selected.date"
                                />
                            </CCol>
                            <CCol sm="4" v-if="selected.sourceType == 'range'">
                                <CInput
                                    label="Select Start Date"
                                    type="date"
                                    v-model="selected.startDate"
                                />
                            </CCol>
                            <CCol sm="4" v-if="selected.sourceType == 'range'">
                                <CInput
                                    label="Select End Date"
                                    type="date"
                                    v-model="selected.endDate"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12" class="text-center">
                                <div style="min-height : 25px"><pulse-loader :loading="loading" color="#2E7D32"></pulse-loader></div>
                                <CInput 
                                    placeholder="Start typing phone number or name to search userwise.."
                                    v-model="searchText"
                                >
                                    <template #prepend>
                                        <CButton color="primary" @click="getData()">
                                        <CIcon name="cil-magnifying-glass"/> Search
                                        </CButton>
                                    </template>
                                </CInput>
                            </CCol>
                        </CRow>
                    </CCardBody>   
                    <CCardFooter class="text-center">
                        <CButton type="submit" size="sm" color="danger mr-4" @click="reset()"><CIcon name="cil-reload"/> Reset Filters</CButton>
                        
                        <CButton type="submit" size="sm" color="primary ml-4" @click="apply()"><CIcon name="cil-check-circle"/> Apply Filters</CButton>
                    </CCardFooter>   
                </CCard>
            </CCol>
        </CRow>
        <CRow>            
            <CCol md="12" class="pad-r-0 pad-l-0">
                
                <CCard>
                    <CCardBody >
                        <b-table 
                            hover
                            selectable
                            select-mode="single"
                            @row-selected="onSelectRow"
                            :items="items"
                            :fields="fields"
                            style="cursor : pointer"
                            id="reportTable"
                            :per-page="perPage"
                            :current-page="currentPage"
                        >
                            <template v-slot:cell(records)="data">
                                {{data.item.records.length}}
                            </template>
                            <template v-slot:cell(distance_covered)="data">
                                {{data.item.distance_covered.toFixed(2)}} km
                            </template>
                            <template v-slot:cell(date)="data">
                                {{data.item.date.substring(0,10)}} 
                            </template>
                            <template v-slot:cell(userid)="data">
                                {{data.item.userid.firstname}} {{data.item.userid.lastname}} 
                            </template>
                            <template v-slot:cell(action)="data">
                                
                                <CButton type="submit" size="sm" color="danger mr-4" @click="deleteRecord(data.item._id)"><small>Delete</small></CButton>
                            </template>
                        </b-table>
                        <b-pagination 
                            align="center"
                            v-model="currentPage"
                            :total-rows="items.length"
                            :per-page="perPage"
                            @page-click="loadMore"
                            aria-controls="reportTable"
                        ></b-pagination>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import axios from 'axios';
import store from '../store';
import JsonExcel from 'vue-json-excel';

export default {
    name : 'Reports',
    components: {
        PulseLoader,
        JsonExcel
    },
    props : {
        small : true,
        
    },
    data() {
        return {
            baseURL : store.state.baseURL,
            items: [
            ],
            filter : {
                fromDate : '',
                toDate : '',
                surveyid : ''
            },
            searchText : '',
            perPage: 15,
            currentPage: 1,
            tableLength : 0,
            loading : true,
            fields : [
                {
                    key : 'tripName',
                    label : 'Trek Name'
                },
                {
                    key : 'area_covered',
                    label : 'Area Covered'
                },
                {
                    key : 'distance_covered',
                    label : 'Distance'
                },
                {
                    key : 'records',
                    label : 'Sightings'
                },
                {
                    key : 'date',
                    label : 'Date'
                },
                {
                    key : 'userid',
                    label : "Uploaded By"
                },
                {
                    key : 'action',
                    label : ''
                }
            ],
            download : [],
            loadPage : 1,
            pagesAvailable : 1,

            selected : {
                circle : null,
                range : null,
                division : null,
                block : null,
                beat : null,
                areaType : null,
                sourceType : null,
                date : null,
                startDate : null,
                endDate : null
            },

            circle  : [],
            range   : [],
            block   : [],
            beat    : [],
            division: [],
            beatLength : 0,
            beatName : '',

            timeTypeRadio : [
                { value: 'month', label: 'Monthly Data' },
                { value: 'year',  label: 'Yearly Data' },
                { value: 'range', label: 'Date Range' },
            ]
            
        }
    },
    beforeMount(){
        var d = new Date();
        var str = d.toISOString();
        str = str.substr(0, 10);
        str = str.replace(/-/g, '');
        this.filename = 'ADACO_Data_'+ str +'.xls';
    },
    created() {
        this.getArea('circle', null, null, null, null);
        this.selected.areaType = 'circle';
        this.selected.sourceType = 'month';        
        this.getRecords();
    },
    methods: {
        updateSourceType(value, event){
            this.selected.sourceType = value;
        },
        apply(){
            var errors = "";
            
            if(this.selected.sourceType == 'range' && (this.selected.startDate == null && this.selected.endDate == null)){
                errors += "Date range cannot be null\n";
            }

            if(errors != "")
            {
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: errors
                });
            }
            else{
                this.getData();
            }

        },
        getData(){
            this.loading = true;
            axios({
                url : this.baseURL + "dashboard/search-trip?p="+1,
                headers : {
                    authorization : store.state.token
                },
                method : "POST",
                data : {
                    date : this.selected.date,
                    startDate : this.selected.startDate,
                    endDate : this.selected.endDate,
                    sourceType : this.selected.sourceType,
                    c : this.selected.circle,
                    d : this.selected.division,
                    r : this.selected.range,
                    b : this.selected.block,
                    userSearch : this.searchText
                }
            })
            .then(res => {
                if(res.data.status)
                {                
                    this.items = res.data.data
                    this.tableLength = this.items.length;                 
                }
                else{
                    this.$notify({
                    group: 'notification',
                    type : 'warn',
                    title: 'Something went wrong',
                    text: 'Error in loading data. Something went wrong!'
                    });
                }
                this.loading = false;
            })
            .catch(err => {
                this.$notify({
                    group: 'notification',
                    type : 'warn',
                    title: 'Important message',
                    text: 'Error in loading data. Please check your internet connection!'
                });
                console.log(err);
                this.loading = false;
            });
        },
        getArea(type, circle, division, range, block){
            this.loading = true;
            var url = this.baseURL + "area/get-distinct?t=" + type;

            if(circle != null)
                url += "&c=" + circle;

            if(division != null)
                url += "&d=" + division;
            
            if(range != null)
                url += "&r=" + range;

            if(block != null)
                url += "&b=" + block;
            

            axios({
                url : url,
                headers : {
                    authorization : store.state.token
                },
                method : "GET"
            })
            .then(res => {
                if(res.data.status)
                {
                    if(type == 'circle'){
                        this.division = [];
                        this.range = [];
                        this.block = [];
                        this.selected.division = null;
                        this.selected.range = null;
                        this.selected.block = null;
                        this.circle = res.data.data; 
                    }   
                    else if(type == 'division'){
                        this.range = [];
                        this.block = [];
                        this.selected.division = null;
                        this.selected.range = null;
                        this.selected.block = null;
                        this.division = res.data.data;      
                                
                    }   
                    else if(type == 'range'){
                        this.block = [];
                        this.selected.range = null;
                        this.selected.block = null;
                        this.range = res.data.data;           
                    }    
                    else if(type == 'block'){
                        this.selected.block = null;
                        this.block = res.data.data;             
                    }   
                }
                else
                {
                    this.$notify({
                        group: 'notification',
                        type : 'warn',
                        title: 'Important message',
                        text: 'Could not load ' + type + '.\n' + res.data.message
                    });
                }
                this.loading = false;
            })
            .catch(err => {

                this.loading = false;

                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: 'Something went wrong!\nCouldn\'t fetch ' + type
                });
                console.log(err);
            });
        },
        reset(){
            this.filter = {
                fromDate : '',
                toDate : '',
                surveyid : ''
            }
            this.items = [];
            this.tableLength = 0;
            this.searchText = '',

            this.getRecords();
        },
        deleteRecord(id){
            if(confirm('Are you sure? Do you want to delete the trek')){
                axios({
                    url : this.baseURL + "trip/delete-any",
                    headers : {
                        authorization : store.state.token
                    },
                    method : "POST",
                    data : {
                        id  : id
                    }
                })
                .then(res => {
                    if(res.data.status)
                    {
                        this.$notify({
                            group: 'notification',
                            type : 'success',
                            title: 'Important message',
                            text: 'Successfully deleted. Please wait you are being redirected'
                        });       
                        this.getData();                    
                    }
                    else
                    {
                        this.$notify({
                            group: 'notification',
                            type : 'warn',
                            title: 'Important message',
                            text: res.data.message
                        });
                    }
                })
                .catch(err => {
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: 'Something went wrong!\nCouldn\'t fetch data'
                    });
                    console.log(err);
                });
            }

        },
        closePreview(){
            this.preview = {
                show : false,
                image : '',
                surveyid : '',
                name : '',
                age : '',
                sex : '',
                area : '',
                date : '',
                time : '',
                sightedBy : '',
                moment : '',
                vulnerability_type : '',
                vulnerability_type_description : ''

            }
        },
        loadMore(){
            ++this.loadPage;
            if(this.tableLength == this.items.length){
                
            }
            else{

                this.getRecords();

            }

        },
        getRecords(){
            this.loading = true;
            axios({
                url : this.baseURL + "dashboard/all-trip?p="+this.loadPage,
                headers : {
                    authorization : store.state.token
                },
                method : "GET"
            })
            .then(res => {
                this.loading = false;
                if(res.data.status)
                {                    
                    this.items.push(...res.data.data);
                    this.tableLength = res.data.count;
                    this.pagesAvailable = res.data.pages;
                    // this.makeDownloadable(this.items);                     
                }
                else
                {
                    this.items = []
                    this.tableLength = 0;
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: res.data.message
                    });
                }
            })
            .catch(err => {
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: 'Error in loading data. Something went wrong!'
                });
                console.log(err);
                this.loading = false;
                return [];
            });

        },
        onSelectRow(row){
            this.openReport(row[0].surveyid);

        },
        selectAnimal(item){
            console.log(item);
        },
        openReport(surveyid){
            window.open(`/trips/${surveyid}`, '_blank');
            // this.$router.push({ path: `/trips/${surveyid}` });
            // this.$router.push({name : 'Conflict Report', params : { surveyid }});
        }
    }
}
</script>

<style scoped>
    .pad-r-0 {
        padding-right: 0px !important;
    }
    .pad-l-0 {
        padding-left: 0px !important;
    }
</style>